import * as React from 'react';
import { NotificationItemView, INotificationItemViewProps } from 'components/Notification/notificationItemView';

export default class NotificationItemConversationAddedView extends NotificationItemView {
    constructor(props: INotificationItemViewProps) {
        super(props);
        this.handleItemClick = this.handleItemClick.bind(this);
    }

    render(): React.ReactNode {
        const { item } = this.props;
        return (
            <button
                className="notification-item pointer"
                onClick={this.handleItemClick}
            >
                <div>
                    <i className={item.iconCss} />
                </div>
                <div className="notification-content">
                    <div className="flex-row pxl-text-sm">
                        New message about&nbsp;<strong>{item.data.employeeName}</strong>
                    </div>
                    <span className="timestamp pxl-text-xs">{item.timeStampText}</span>
                </div>
            </button>
        );
    }

    private handleItemClick(): void {
        this.props.item.onClick();
    }
}